import React from 'react';
import PropTypes from 'prop-types';
import {
  LessonDisplay,
  setupTokenProvider
} from '@ramsey-plus-components/learn-ui';
import tokenProviderFactory from '../api/token_provider';

const LessonDisplayContainer = ({ lessonData, currentUser }) => {
  const { action_groups: actionGroups, title } = lessonData;
  const tokenProvider = tokenProviderFactory();
  setupTokenProvider(tokenProvider);

  // This can return url params too
  const getEndOfUrlWithId = (url) => url.substring(url.lastIndexOf('/') + 1);

  let actionItem = null;

  for (let group = 0; group < actionGroups.length; group++) {
    const actionItems = actionGroups[group].action_items;

    for (let item = 0; item < actionItems.length; item++) {
      const endOfUrl = getEndOfUrlWithId(window.location.href);
      if (endOfUrl.indexOf(actionItems[item].id) > -1) {
        actionItem = actionItems[item];
      }
    }
  }

  const completionUrl =
    actionItem.course_id === 'financial-peace-university'
      ? '/app/dashboard'
      : `/learn/${actionItem.course_id}`;

  return (
    <LessonDisplay
      actionGroups={actionGroups}
      actionItem={actionItem}
      completionUrl={completionUrl}
      surveyConfig={{ tokenProvider }}
      title={title}
      userData={currentUser}
    />
  );
};

LessonDisplayContainer.propTypes = {
  lessonData: PropTypes.object,
  actionItem: PropTypes.object,
  actionGroups: PropTypes.object,
  currentUser: PropTypes.object
};

export default LessonDisplayContainer;
